import type { OperatorPasskeysResponse } from "@esi/shared";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api.ts";
import { ok } from "../api-errors.ts";
import type { StepUpCalls } from "../security/step-up.tsx";
import { useCsrfHeaders } from "./operator.tsx";
import { consoleKeys } from "./queries.ts";

const account = api.api.operator.account;

/**
 * The operator's step-up for every console action that asks for one (#405): the password and
 * authenticator code, or one of the operator's passkeys, offered first when one is registered
 * (the list needs no step-up, #389). The server never lets a passkey step-up add a passkey, so
 * the Profile's add asks for the code only (`offerPasskey` false there).
 */
export function useOperatorStepUp(): { calls: StepUpCalls; hasPasskey: boolean } {
  const csrf = useCsrfHeaders();
  const passkeys = useQuery({
    queryKey: consoleKeys.passkeys,
    queryFn: async (): Promise<OperatorPasskeysResponse> => ok(await account.passkeys.$get()),
    retry: false,
  });
  const calls: StepUpCalls = {
    password: (json) => account.reauth.$post({ json }, csrf),
    passkey: {
      options: () => account.reauth.passkey.options.$post(undefined, csrf),
      verify: (credential) => account.reauth.passkey.$post({ json: { credential } }, csrf),
    },
  };
  const listed = passkeys.data?.available ? passkeys.data.passkeys : null;
  return { calls, hasPasskey: (listed?.length ?? 0) > 0 };
}
